import { Autocomplete, TextField, Typography } from "@mui/material";

export type GenericSearchSelectProps = {
  value: string | null | undefined;
  setValue: (value: string | null) => void;
  options: string[];
  label: string;
  disabled?: boolean;
  getOptionDisabled?: (option: string) => boolean;
  getOptionLabel?: (option: string) => string;
  disablePortal?: boolean;
};

export const GenericSearchSelect = ({
  value,
  setValue,
  options,
  label,
  disabled = false,
  getOptionDisabled,
  getOptionLabel,
  disablePortal = true,
}: GenericSearchSelectProps) => {
  return (
    <Autocomplete
      disablePortal={disablePortal}
      options={options}
      fullWidth
      sx={{
        "& .MuiAutocomplete-inputRoot.Mui-disabled:before": {
          borderBottom: "none",
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          key={`${label}-select`}
          label={label}
          autoComplete="off"
        />
      )}
      isOptionEqualToValue={(option, value) => {
        if (value === "") return false;
        return option === value;
      }}
      disabled={disabled}
      getOptionDisabled={getOptionDisabled}
      value={value || null}
      onChange={(_, newValue) => {
        setValue(newValue);
      }}
      renderOption={(props, option) => (
        <li {...props} key={`li-${option}`}>
          <div className="flex gap-3">
            <div>
              <Typography variant="body1" fontWeight="500">
                <span>{getOptionLabel ? getOptionLabel(option) : option}</span>
              </Typography>
            </div>
          </div>
        </li>
      )}
      ListboxProps={{ style: { maxHeight: 200 } }}
      getOptionLabel={getOptionLabel || ((option) => option)}
    />
  );
};

export default GenericSearchSelect;
